import { render, staticRenderFns } from "./partnerList.vue?vue&type=template&id=5192e431&"
import script from "./partnerList.vue?vue&type=script&lang=js&"
export * from "./partnerList.vue?vue&type=script&lang=js&"
import style0 from "./partnerList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports